import { render, staticRenderFns } from "./distributionStation-to-customer-cost.vue?vue&type=template&id=18818fed&scoped=true"
import script from "./distributionStation-to-customer-cost.vue?vue&type=script&lang=js"
export * from "./distributionStation-to-customer-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18818fed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18818fed')) {
      api.createRecord('18818fed', component.options)
    } else {
      api.reload('18818fed', component.options)
    }
    module.hot.accept("./distributionStation-to-customer-cost.vue?vue&type=template&id=18818fed&scoped=true", function () {
      api.rerender('18818fed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/distributionStation-management/distributionStation-list/distributionStation-to-customer-cost.vue"
export default component.exports